import BootstrapTable, {
  ColumnDescription,
  RowEventHandlerProps,
  SortOrder,
  TableChangeHandler,
} from 'react-bootstrap-table-next';

export interface TableSort {
  dataField?: any;
  order: SortOrder;
  sortFunc?: any;
  sortCaret?: any;
}
interface EndlessScrollingTableProps {
  loading?: boolean;
  timeoutError?: boolean;
  data: any[];
  columns: ColumnDescription[];
  page: number;
  rowEvents?: Partial<RowEventHandlerProps>;
  rowClasses?: string | ((row: any, rowIndex: number) => string);
  sort?: TableSort;
  handleTableChange?: TableChangeHandler<any>;
}

// Fixes issue that sometimes appear
// "BootstrapTable' cannot be used as a JSX component. Its type 'typeof BootstrapTable' is not a valid JSX element type"
const TableComponent = BootstrapTable as any;

export const EndlessScrollingTable = ({
  data,
  columns,
  page,
  rowEvents,
  rowClasses,
  sort,
  handleTableChange,
  loading,
  timeoutError,
}: EndlessScrollingTableProps) => {
  return (
    <TableComponent
      bootstrap4
      keyField="id"
      wrapperClasses="table-responsive unselectable-table"
      id="dashBoard"
      remote={{ pagination: false, filter: false, sort: true }}
      bordered={false}
      data={data}
      columns={columns}
      rowEvents={rowEvents}
      rowClasses={rowClasses}
      sort={sort}
      onTableChange={handleTableChange}
      noDataIndication={() =>
        loading ? (
          <div className="text-center">
            Loading <span className="dots" />
          </div>
        ) : timeoutError ? (
          <div className="text-center my-2">An error occurred</div>
        ) : (
          <div className="text-center my-2">No results</div>
        )
      }
    />
  );
};
